import SquareTransactions from './SquareTransactions';

export default SquareTransactions;